


























































































































































































































import { defineComponent } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import {
  Cluster as ClusterFromStore,
  Register as RegisterFromStore,
} from '@/features/core/store/page-modules/modbus-edit-registers/modbus-edit-register.module';
import { ModbusMappings, ModbusMappings_modbusMappingConfig } from '../__generated__/ModbusMappings';
import { APOLLO_CLIENT } from '@/features/core/container/model';
import modbusMappingsQuery from '@/features/app-heating-system/views/tree-node/get-modbus-mappings-cust-id.gql';

interface Register {
  registerNumber: string | null;
  registerName: string;
  tableData: string[] | null;
  model: string;
  unit: string | null;
}

interface dataList {
  registerNumber: string | null;
  registerName: string;
}

export default defineComponent({
  data() {
    return {
      selectedTab: '', // Default selected tab
      modelNames: [] as string[], // Initialize the modelName array
      registerData: new Map<string, Register[]>(),
      defaultTabelleData: [] as dataList[],
      searchString: '', // Initialize searchString
      clustersFromStore: {} as { [key: string]: ClusterFromStore[] },
      modbusMappingConfigs: [] as ModbusMappings_modbusMappingConfig[],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      stateClusterData: 'clusterData',
      showEditMetricsModal: 'showEditMetricsModal',
      selectedCustomerName: 'selectedCustomerName',
      selectedCustomerId: 'selectedCustomerId',
      tableData: 'tableData',
    }),
    editRegisters(): Register[] {
      const currentModelCluster = this.stateClusterData.get(this.selectedTab);
      return (
        this.registerData
          .get(this.selectedTab)
          ?.filter((register) => register?.tableData?.includes('edit'))
          ?.filter(
            (register) =>
              !currentModelCluster?.some((clusters: ClusterFromStore) => this.isRegisterInCluster(register, clusters)),
          ) || []
      );
    },
    filteredRegisters(): Register[] {
      const registers = this.registerData.get(this.selectedTab) || [];

      const filtered = this.filterRegistersThatAreAlreadyDragged(registers).filter(
        (register) => !this.isRegisterInactive(register),
      );

      if (this.searchString === '') {
        return this.sortByRegsiterNumber(filtered);
      } else {
        return this.sortByRegsiterNumber(
          filtered.filter((register) =>
            ((register.registerNumber ?? '') + (register.tableData ?? '') + register.registerName)
              .toLowerCase()
              .includes(this.searchString),
          ),
        );
      }
    },
    maxClustersReached(): boolean {
      const registers = (this.registerData.get(this.selectedTab) || []).filter((register) =>
        register?.tableData?.includes('edit'),
      );
      return this.getClusters().length >= registers.length;
    },
  },
  watch: {
    async selectedCustomerId(val) {
      if (val) {
        await this.$store.dispatch('loadClusterTableConfig', {
          apolloClient: this.$apollo,
          customerId: val,
        });
      }
    },
    stateClusterData(val: Map<string, ClusterFromStore[]>) {
      if (val) {
        val.forEach((value: ClusterFromStore[], model: string) => {
          this.$set(this.clustersFromStore, model, value);
        });
      }
    },
    async showEditMetricsModal(val) {
      if (val && this.selectedCustomerId) {
        await this.$store.dispatch('loadClusterTableConfig', {
          apolloClient: this.$apollo,
          customerId: this.selectedCustomerId,
        });
        this.modbusMappingsTable(this.selectedCustomerId).then(() => {
          this.removeAllEmptyClusters();
        });
      }
    },
  },
  async mounted() {
    if (this.selectedCustomerId) {
      await this.$store.dispatch('loadClusterTableConfig', {
        apolloClient: this.$apollo,
        customerId: this.selectedCustomerId,
      });
    }
  },
  methods: {
    getClusters(): ClusterFromStore[] {
      return this.clustersFromStore[this.selectedTab] || [];
    },
    allowDrop(event: any) {
      event.preventDefault();
    },
    drag(event: any) {
      event.dataTransfer.setData('drop', event.target.id);
    },
    drop(event: any, index: number) {
      event.preventDefault();
      const data = event.dataTransfer.getData('drop');
      const draggedElement = document.getElementById(data);

      const dataList: dataList = {
        registerNumber: draggedElement?.querySelector('td:nth-child(2)')?.textContent ?? '',
        registerName: draggedElement?.querySelector('td:nth-child(3)')?.textContent ?? '',
      };

      const metricType = draggedElement?.querySelector('td:nth-child(4)')?.textContent ?? '';

      const allowTabelleDrop =
        metricType.includes('table') && !metricType.includes('graph') && typeof index === 'undefined';
      const allowClusterDrop = metricType.includes('edit') && typeof index !== 'undefined';

      // Prevent dragging to another cluster if already present in any cluster
      if (allowClusterDrop) {
        const currentModelCluster = this.getClusters();
        const alreadyInAnyCluster = currentModelCluster.some((cluster: ClusterFromStore) =>
          cluster.registers.some((r: RegisterFromStore) => r.registerName === dataList.registerName),
        );
        if (alreadyInAnyCluster) {
          return;
        }
        this.handleEditDrop(dataList, index);
      } else if (allowTabelleDrop) {
        this.addToTableData(dataList);
      } else {
        return; // Invalid metric type
      }
    },
    handleEditDrop(dataList: dataList, index?: number) {
      let targetIdx = index;
      if (typeof targetIdx === 'undefined') {
        const clusters = this.stateClusterData.get(this.selectedTab) || [];
        const firstCluster = clusters.find((c: ClusterFromStore) => c.idx === 1) || clusters[0];
        if (firstCluster) {
          targetIdx = firstCluster.idx;
        }
      }
      const inputEl = document.querySelector(
        `#${this.selectedTab.replace(/\s+/g, '_')}-${targetIdx}-input`,
      ) as HTMLInputElement | null;
      let clusterName = inputEl ? inputEl.value.trim() : '';

      if (!clusterName) {
        const cluster = (this.stateClusterData.get(this.selectedTab) || []).find(
          (c: ClusterFromStore) => c.idx === targetIdx,
        );
        clusterName = cluster ? cluster.name : 'Cluster 1';
      }
      const register = this.registerData
        .get(this.selectedTab)
        ?.find((r: Register) => r.registerName === dataList.registerName);
      if (typeof targetIdx !== 'undefined') {
        this.addClusterDataToStore({
          model: this.selectedTab,
          clusterIdx: targetIdx,
          name: clusterName,
          register: {
            ...dataList,
            model: this.selectedTab,
            tableData: ['edit'],
            value: null,
            unit: register?.unit,
          } as Register,
        });
      }
    },
    addClusterDataToStore(value: { model: string; name: string; clusterIdx: number; register: Register | null }): void {
      this.$store.commit('addClusterData', {
        model: value.model,
        name: value.name,
        clusterIdx: value.clusterIdx,
        register: value.register,
      });
      this.$set(this.clustersFromStore, value.model, this.stateClusterData.get(value.model));
      this.saveClustersToLocalStorage();
    },
    addToTableData(dataList: dataList): void {
      // Check if the registerNumber already exists in tableData or defaultTabelleData
      const isDuplicate =
        this.tableData.some((item: RegisterFromStore) => {
          return item.registerName === dataList.registerName;
        }) ||
        this.defaultTabelleData.some((item: dataList) => {
          return item.registerName === dataList.registerName;
        });
      if (!isDuplicate) {
        this.$store.commit('addTabelleData', {
          ...dataList,
          model: this.selectedTab,
          tableData: ['table'],
        } as Register);
      }
      this.saveTableDataToLocalStorage();
    },
    saveTableDataToLocalStorage(): void {
      this.$store.dispatch('saveTableDataToLocalStorage', {
        customerId: this.selectedCustomerId,
        apolloClient: this.$apollo,
      });
    },
    restoreFromDroppedTable(item: dataList): void {
      const restoredItem = { ...item, tableData: ['table'] };
      this.$store.commit('removeTabelleData', { ...restoredItem, model: this.selectedTab });
      this.saveTableDataToLocalStorage();
    },

    restoreFromClusterTable(item: RegisterFromStore, cluster: ClusterFromStore): void {
      const modelKey = this.selectedTab;
      this.$store.commit('removeClusterData', {
        model: modelKey,
        clusterIdx: cluster.idx,
        name: cluster.name,
        register: item,
      });

      this.saveClustersToLocalStorage();
    },

    closeModal() {
      this.resetSearch();
      this.modelNames = [];
      this.registerData.clear();
      this.defaultTabelleData = [];
      this.selectedTab = '';
      this.$store.commit('showEditMetricsModal', false);
    },

    searchFilter({ target }: { target: HTMLInputElement }) {
      this.searchString = target.value.trim().toLowerCase();
    },
    async modbusMappingsTable(customerId: string): Promise<void> {
      this.loading = true;
      try {
        const { data } = await this.$apollo.query<ModbusMappings>({
          client: APOLLO_CLIENT.PORTAL_CLIENT,
          query: modbusMappingsQuery,
          variables: {
            customerId: customerId,
          },
        });

        // Convert tableData to array for each mappingRule
        const modbusMappingConfigs = data.modbusMappingConfig.map((config) => ({
          ...config,
          mappingRules: config.mappingRules.map((rule) => ({
            ...rule,
            tableData: Array.isArray(rule.tableData) ? rule.tableData : rule.tableData ? [rule.tableData] : [],
          })),
        }));

        this.modbusMappingConfigs = modbusMappingConfigs;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        this.loading = false;
      }

      const graphRegisterData = [] as Register[];

      this.modbusMappingConfigs.forEach((config) => {
        const deviceModel = config.model;
        if (!this.modelNames.includes(deviceModel)) {
          this.modelNames.push(deviceModel);
        }

        const existingRegisters = this.registerData.get(deviceModel) || [];

        // Filter and convert all mapping rules where the tableData is either table or edit
        const filteredRegisters: Register[] = config.mappingRules
          .filter((mapping) => mapping?.tableData?.includes('table') || mapping?.tableData?.includes('edit'))
          .map((mapping) => ({
            registerName: mapping.registerName,
            registerNumber: mapping.registerNumber,
            tableData: mapping.tableData,
            model: deviceModel,
            unit: mapping.unit,
          }));

        // remove duplicates from filteredRegisters based on registerName
        const uniqueFilteredRegisters =
          existingRegisters.length == 0
            ? filteredRegisters
            : filteredRegisters.filter((register) => {
                return !existingRegisters.some(
                  (existingRegister) => existingRegister.registerName === register.registerName,
                );
              });
        if (uniqueFilteredRegisters.length > 0) {
          existingRegisters.push(...uniqueFilteredRegisters);
        }
        this.registerData.set(deviceModel, existingRegisters);

        // Filter all mapping rules where the tableData is graph
        const graphRegisters: Register[] = config.mappingRules
          .filter((mapping) => mapping?.tableData?.includes('graph'))
          .map((mapping) => ({
            registerName: mapping.registerName,
            registerNumber: mapping.registerNumber,
            tableData: mapping.tableData,
            model: deviceModel,
            unit: mapping.unit,
          }));

        graphRegisterData.push(...graphRegisters);
      });

      // Filter unique graph registers based on registerName
      const filteredGraphRegisters = graphRegisterData.reduce((acc: Register[], register) => {
        if (!acc.some((r) => r.registerName === register.registerName)) {
          acc.push(register);
        }
        return acc;
      }, []);

      // Sort the filteredGraphRegisters by registerName in ascending order (German locale)
      filteredGraphRegisters.sort((a, b) => a.registerName.localeCompare(b.registerName, 'de'));
      this.defaultTabelleData = filteredGraphRegisters.map((graphRegister) => ({
        ...graphRegister,
      })); // save unique graph registers as tabelle dataList

      // Create Cluster 1 for each model if it doesn't exist
      this.modelNames.forEach((model) => {
        if (!this.stateClusterData.get(model) || this.stateClusterData.get(model).length === 0) {
          this.addClusterDataToStore({
            model,
            name: `Cluster 1`,
            clusterIdx: 1,
            register: null,
          });
        }
      });
      const selectedTabmodelName = this.modelNames[0] ?? 'Tab1';
      this.selectedTab = selectedTabmodelName; // Set the default selected tab to the first modelName
    },
    isRegisterInCluster(register: Register, cluster: ClusterFromStore): boolean {
      return cluster.registers.some((r) => r.registerName === register.registerName);
    },
    handlePlusClick() {
      if (this.editRegisters.length === 0 || this.maxClustersReached) {
        return;
      }

      const clusters = this.stateClusterData.get(this.selectedTab) || [];
      // Find the highest idx used so far
      const maxIdx = clusters.length > 0 ? Math.max(...clusters.map((c: ClusterFromStore) => c.idx)) : 0;
      let nextIdx = maxIdx + 1;

      // Default name is "Cluster X"
      let defaultName = `Cluster ${nextIdx}`;
      const existingNames = clusters.map((c: ClusterFromStore) => c.name.trim());

      // Ensure no duplicate name (in case user renamed a cluster to "Cluster X")
      while (existingNames.includes(defaultName)) {
        nextIdx++;
        defaultName = `Cluster ${nextIdx}`;
      }

      this.addClusterDataToStore({
        model: this.selectedTab,
        name: defaultName,
        clusterIdx: nextIdx,
        register: null,
      });
    },

    updateRegisterBySelectedModel(model: string) {
      this.selectedTab = model; // Update the selected tab
      this.resetSearch();
      this.removeAllEmptyClusters(model);
    },
    saveClustersToLocalStorage() {
      this.$store.dispatch('saveClusterConfigToLocalStorage', {
        customerId: this.selectedCustomerId,
        apolloClient: this.$apollo,
      });
    },
    updateClusterName({ model, name, idx }: { model: string; name: string; idx: number }) {
      this.$store.commit('updateClusterName', {
        model: model,
        name: name,
        idx: idx,
      });
      this.$set(this.clustersFromStore, model, this.stateClusterData.get(model));
      this.saveClustersToLocalStorage();
    },
    resetSearch() {
      (this.$refs.searchInput as HTMLInputElement).value = '';
      this.searchString = '';
    },
    editClusterName(event: Event, value: { model: string; idx: number; name: string }) {
      const target = event.target as HTMLInputElement;
      const newName = target.value.trim();
      const oldName = value.name || `Cluster ${value.idx + 1}`;

      // If input is blank, do nothing
      if (!newName) {
        target.value = oldName;
        return;
      }

      // Check for duplicate names in other clusters
      const clusters = this.getClusters();
      const isDuplicate = clusters.some((c: ClusterFromStore) => c.idx !== value.idx && c.name.trim() === newName);
      if (isDuplicate) {
        alert('Doppelte Clusternamen sind nicht zulässig.');
        target.value = oldName; // revert input field value
        return;
      }

      // Only rename if the name actually changed
      if (newName !== value.name) {
        this.updateClusterName({ model: this.selectedTab, idx: value.idx, name: newName });
      }
    },
    sortByRegsiterNumber(registers: Register[]): Register[] {
      return registers.slice().sort((a, b) => {
        if (a.registerNumber === b.registerNumber) return 0;
        if (a.registerNumber === null) return 1;
        if (b.registerNumber === null) return -1;

        const aRegisterNumber = Number(a.registerNumber);
        const bRegisterNumber = Number(b.registerNumber);

        return aRegisterNumber - bRegisterNumber;
      });
    },
    filterRegistersThatAreAlreadyDragged(registers: Register[]): Register[] {
      const currentModelCluster = this.getClusters();

      return registers.filter((register) => {
        const isEditAndTable = register.tableData?.includes('edit') && register.tableData?.includes('table');
        const isEditOnly = register.tableData?.includes('edit') && !register.tableData?.includes('table');

        const isInCluster = currentModelCluster?.some((cluster: ClusterFromStore) =>
          this.isRegisterInCluster(register, cluster),
        );

        const isInTable = this.tableData.some(
          (tableRegister: RegisterFromStore) => tableRegister.registerName === register.registerName,
        );

        // If register is both edit and table, only remove if present in BOTH cluster and table
        if (isEditAndTable) {
          return !(isInTable && isInCluster);
        }

        // If register is edit only, remove if present in ANY cluster
        if (isEditOnly) {
          return !isInCluster;
        }

        // For other types, use your existing logic
        return !isInCluster && !isInTable;
      });
    },
    removeAllEmptyClusters(model?: string) {
      const models = model ? [model] : this.modelNames;
      let changed = false;
      models.forEach((m) => {
        const clusters = this.stateClusterData.get(m) || [];
        // If there is at least one non-empty cluster, remove all empty clusters
        const hasNonEmpty = clusters.some((c: ClusterFromStore) => c.registers && c.registers.length > 0);
        let filtered;
        if (hasNonEmpty) {
          filtered = clusters.filter((c: ClusterFromStore) => c.registers && c.registers.length > 0);
        } else {
          // If all clusters are empty, keep the first one (by idx)
          const minIdx = Math.min(...clusters.map((c: ClusterFromStore) => c.idx));
          filtered = clusters.filter((c: ClusterFromStore) => c.idx === minIdx);
        }
        if (filtered.length !== clusters.length) {
          changed = true;
          this.$set(this.clustersFromStore, m, filtered);
          this.$store.commit('setClusterData', new Map([[m, filtered]]));
        }
      });
      if (changed) {
        this.saveClustersToLocalStorage();
      }
    },
    isRegisterInactive(register: Register): boolean {
      // Inactive if both 'graph' and 'table' are present
      return (register?.tableData?.includes('graph') && register?.tableData?.includes('table')) || false;
    },
    isEditAndGraph(tableData: string[] | null): boolean {
      return Array.isArray(tableData) && tableData.includes('edit') && tableData.includes('graph');
    },
  },
});
